import React from 'react';
import { useLocation } from 'react-router-dom';
import Hidden from '@mui/material/Hidden';
import DesktopNavbar from './DesktopNavbar';
import MobileNavbar from './MobileNavbar';

const ROUTES_WITHOUT_NAVBAR = ['/user-login'];

const WorkspaceNavbar = () => {
  const { pathname } = useLocation();
  if (ROUTES_WITHOUT_NAVBAR.includes(pathname)) return null;
  return (
    <>
      <Hidden mdUp>
        <MobileNavbar />
      </Hidden>
      <Hidden mdDown>
        <DesktopNavbar />
      </Hidden>
    </>
  );
};

export default WorkspaceNavbar;
